import React from 'react';
import { Link, useLocation } from 'react-router';
import Server from '../../js/config/_server';
import { useMiwiStore, userStore, generalStore } from '../../store';
import Helpers from '../../js/helpers';
import { COOKIE_KEYS, ROUTES } from '../../js/_constants';
import Logo from '../../components/logo/Logo';
import { auth } from '../../js/GRP';
import './errorView.scss';

const ErrorView = () => {
    const location = useLocation();
    let errorCode: number;
    let errorMessage: React.ReactNode;
    const { resetUser } = userStore();
    const { miwiLogout } = useMiwiStore();
    const { setAuthenticated } = generalStore();

    switch (location.pathname) {
        case '/401':
            errorCode = 401;
            errorMessage = (
                <>
                    <h1>Unauthorized</h1>
                    <h2>The request has not been completed because it lacks valid authentication credentials for the requested resource.</h2>
                </>
            );
            break;
        
        case '/403':
            errorCode = 403;
            errorMessage = (
                <>
                    <h1>You shall not pass</h1>
                    <h2>Access Denied</h2>
                </>
            );
            break;

        case '/500':
            errorCode = 500;
            errorMessage = (
                <>
                    <h1>Something went wrong.</h1>
                    <h2>Internal Server Error</h2>
                </>
            );

            break;
        case '/404':
            errorCode = 404;
            errorMessage = (
                <>
                    <h1>It seems we can't find what you are looking for</h1>
                    <h2>Page not found</h2>
                </>
            );

            break;
        default:
            errorCode = 0;
            errorMessage = (
                <>
                    <h1>It seems we can't find what you are looking for</h1>
                    <h2>Page not found</h2>
                </>
            );

            break;
    }

    const logout = () => {
        Helpers.removeCookie(COOKIE_KEYS.TOKEN);
        Helpers.removeCookie(COOKIE_KEYS.REFRESH_TOKEN);
        Helpers.removeCookie(COOKIE_KEYS.ID_TOKEN);
        setAuthenticated(false);
        resetUser();
        miwiLogout();
        auth.logout();
    };

    return (
        <div className="b-error-view">
            <div className="main-content">
                <Link className="back-button" to={ROUTES.DASHBOARD}>
                    <p>
                        <span className="arrow">&lt;</span> Back to Dashboard
                    </p>
                </Link>
                <div className="logo-wrapper">
                    <Logo classNames="logo" />
                </div>
                {errorMessage}
                {errorCode !== 0 && <h3 className="error-code">{errorCode}</h3>}
                <div className="help-content">
                    <p className="help-title">How may we help?</p>
                    <p className="help-desc">
                        Use the link below to contact Support.
                    </p>
                    <p className="help-desc">
                        We will look at the issue promptly.
                    </p>
                </div>
            </div>
            <footer>
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href={Server.systemSupport}
                >
                    <p>
                        Contact Support<span className="arrow"> &gt;</span>
                    </p>
                </a>
                <Link
                    className="logout-button"
                    onClick={() => logout()}
                    to={ROUTES.NO_AUTHENTICATED}
                >
                    <p>
                        Logout<span className="arrow"> &gt;</span>
                    </p>
                </Link>
            </footer>
        </div>
    );
};
export default ErrorView;
